import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';

import { reloadSpace } from '~src/spacesPlatform/sagas/content/RefreshContentSagas';

import { ServerUserDelete, ServerUserEditSiteMembership, ServerUserForcePasswordUpdate, ServerUserResetLoginRateLimiting
} from '../../app/actions/AppActionTypes';
import { requestFailed } from '../../app/actions/RequestFailedAction';
import { forcePasswordUpdateOnServerUsers } from '../../authentication/actions/ForcePasswordUpdateAction';
import { resetLoginRateLimitingOnServerUsers } from '../../authentication/actions/ResetLoginRateLimitingAction';
import { Messages } from '../../codegen/Localize';
import { Set } from '../../ts/models/Set';
import { EditSiteMembershipAction } from '../services/EditSiteMembershipAction';
import { RemoveUsersAction } from '../services/RemoveUsersAction';
import { ServerUserMenuAction } from '../users/actions/ServerUserMenuActions';
import { IServerUserInfo } from '../users/models/IServerUserInfo';

export function deleteUsers(users: IServerUserInfo[]) {
  return RemoveUsersAction.showDeleteUsersFromServerDialog(Set.fromIdItemArray(users));
}

export function* handleDeleteUsers(action: ServerUserMenuAction): SagaIterator {
  try {
    yield call(deleteUsers, action.items);

    // Need to reload space for license bar updates
    yield call(reloadSpace);
  } catch (e) {
    // This is to prevent error notifcation from showing up when the dialog is dismissed
    // To be fixed after TFSID 1121927
    return;
  }
}

export function editSiteMembership(users: IServerUserInfo[]) {
  return EditSiteMembershipAction.showEditSiteMembershipDialog(Set.fromIdItemArray(users));
}

export function* handleEditSiteMembership(action: ServerUserMenuAction): SagaIterator {
  try {
    yield call(editSiteMembership, action.items);

    // Need to reload space for license bar updates
    yield call(reloadSpace);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function forcePasswordUpdate(users: IServerUserInfo[]) {
  return forcePasswordUpdateOnServerUsers(Set.fromIdItemArray(users));
}

export function* handleForcePasswordUpdate(action: ServerUserMenuAction): SagaIterator {
  try {
    yield call(forcePasswordUpdate, action.items);

    // Need to reload space for license bar updates
    yield call(reloadSpace);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function resetLoginRateLimiting(users: IServerUserInfo[]) {
  return resetLoginRateLimitingOnServerUsers(Set.fromIdItemArray(users));
}

export function* handleResetLoginRateLimiting(action: ServerUserMenuAction): SagaIterator {
  try {
    yield call(resetLoginRateLimiting, action.items);

    // Need to reload space for license bar updates
    yield call(reloadSpace);
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function* rootServerUserMenuActionSaga(): SagaIterator {
  yield takeEvery(ServerUserEditSiteMembership, handleEditSiteMembership);
  yield takeEvery(ServerUserDelete, handleDeleteUsers);
  yield takeEvery(ServerUserForcePasswordUpdate, handleForcePasswordUpdate);
  yield takeEvery(ServerUserResetLoginRateLimiting, handleResetLoginRateLimiting);
}
